// utils/routeMapper.js (or similar)
export const getRouteForTab = (tabName) => {
    switch (tabName) {
      case 'Payments':
        return '/paymentslist';
      case 'RecurringPayment':
        return '/rec-payments-list';
      case 'Pledges':
        return '/pledges-list';
      case 'Pledges_Reccuring':
        return '/rec-pledges-list';
      case 'Donors':
        return '/donors-list';
      case 'Donors_Reminders':
        return '/reminders-list';
      case 'School_Parents':
        return '/parents-list';
      case 'School_StudentList':
        return '/students-list';
      case 'School_Payments':
        return '/school-payments';
      case 'School_Charges':
        return '/school-charges';
      case 'SchoolRecurringPayment':
        return '/school-recurring-payments';
      case 'School_RecurringCharges':
        return '/school-recurring-charges';
      case 'MealPunch':
        return '/meal-punch';
      case 'School':
        return '/registration';
      default:
        return null;
    }
  };

export const isMealPunchOnly = (tabs) =>
  Array.isArray(tabs) && tabs.length > 0 && tabs.every((tab) => tab === 'MealPunch');
  